export default __webpack_public_path__ + "cc6c9643.png";